import { useFlag } from '@unleash/proxy-client-react';
import React, { lazy } from 'react';
import {
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';
import { PrivateRoute } from '~/components/route';
import { FEATURE_FLAG } from '~/configurations/constants';

/* eslint-disable max-len */
const Auth = lazy(() => import(/* webpackChunkName: "AuthRoutes" */ './Auth'));
const NotFoundPage = lazy(() => import(/* webpackChunkName: "NotFoundPage" */ '~/modules/app/NotFoundPage'));
const Payables = lazy(() => import(/* webpackChunkName: "PayablesRoutes" */ './Payables'));
const PersonalAccountPage = lazy(() => import(/* webpackChunkName: "PersonalAccountPage" */ '~/modules/personal-account/Page'));
const Receivables = lazy(() => import(/* webpackChunkName: "ReceivablesRoutes" */ './Receivables'));
const Shipments = lazy(() => import(/* webpackChunkName: "ShipmentsRoutes" */ './Shipments'));
const ShippersRoutes = lazy(() => import(/* webpackChunkName: "ShippersRoutes" */ './Shippers'));
const TransportersRoutes = lazy(() => import(/* webpackChunkName: "TransportersRoutes" */'./Transporters'));
const WelcomePage = lazy(() => import(/* webpackChunkName: "WelcomePage" */ '~/modules/app/WelcomePage'));
const PayablesPaymentStatementPage = lazy(() => import(/* webpackChunkName: "PaymentStatementPage" */ '~/modules/payables-payment-statement/Page'));
/* eslint-enable max-len */

/**
 * For better readability, please follow src/routes/README.md
 */
export default function AppRoutes() {
  const KC_LTMS_RECEIVABLE_UPI_MIGRATION = useFlag(FEATURE_FLAG.KC_LTMS_RECEIVABLE_UPI_MIGRATION);

  return (
    <Routes>
      {/* 1. Auth Routes */}
      <Route path="/auth/*" element={<Auth />} />

      {/* 2. Logged-in Routes */}
      <Route path="/" element={<PrivateRoute />}>
        {/* Namespaced Routes */}
        <Route path="payables/*" element={<Payables />} />
        <Route path="shipments/*" element={<Shipments />} />
        <Route path="shippers/*" element={<ShippersRoutes />} />
        <Route path="transporters/*" element={<TransportersRoutes />} />

        {
          !KC_LTMS_RECEIVABLE_UPI_MIGRATION && (
            <Route path="receivables/*" element={<Receivables />} />
          )
        }

        {/* Individual Pages */}
        <Route path="personal-account" element={<PersonalAccountPage />} />

        <Route path="" element={<Navigate to="shippers" />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      {/* 3. Custom Routes */}
      <Route path="/welcome" element={<WelcomePage />} />
      <Route path="/statement/:payableKsuid" element={<PayablesPaymentStatementPage />} />
    </Routes>
  );
}
